import campaignV2CreatorsFetchers from '@/api/fetchers/campaignV2Creators';
import type {CampaignCreatorCounts} from '@/views/campaigns/creators-tab/types/creatorTabTypes';
import useDataQuery from '@/hooks/use-data-query';

interface UseCampaignV2CreatorsCountsQueryParams {
  brandId?: string;
  campaignId?: string;
  enabled?: boolean;
}

export const CAMPAIGN_V2_CREATORS_COUNTS_BASE_QUERY_KEY =
  'campaignV2CreatorsCounts';

function useCampaignV2CreatorsCountsQuery({
  brandId,
  campaignId,
  enabled = true,
}: UseCampaignV2CreatorsCountsQueryParams) {
  const response = useDataQuery<CampaignCreatorCounts>({
    queryKey: [
      CAMPAIGN_V2_CREATORS_COUNTS_BASE_QUERY_KEY,
      {campaignId, brandId},
    ],
    queryFn: campaignV2CreatorsFetchers.counts,
    enabled: !!campaignId && enabled,
    meta: {
      campaignId,
      brandId,
    },
  });

  const counts: CampaignCreatorCounts =
    (response.data as CampaignCreatorCounts) || {
      applications: 0,
      hired: 0,
      declined: 0,
      invited: 0,
      unreadApplications: false,
      unreadHired: false,
      unreadDeclined: false,
    };

  return {
    ...response,
    counts,
  };
}

export default useCampaignV2CreatorsCountsQuery;
